import { useMemo } from 'react';
import { DashboardMonthlySalesChart } from '../components/dashboard/DashboardMonthlySalesChart';
import { DashboardMonthlyVisitation } from '../components/dashboard/DashboardMonthlyVisitation';
import { DashboardProjectsByCompany } from '../components/dashboard/DashboardProjectsByCompany';
import { DashboardTasksPanel } from '../components/dashboard/DashboardTasksPanel';
import { PageHeader } from '../components/ui/PageHeader';
import { useCrmData } from '../contexts/CrmDataContext';
import { usePortal } from '../contexts/PortalContext';
import { groupProjectsByCompany, sortDashboardTasks } from '../utils/dashboardHelpers';

export function DashboardPage() {
  const { kind } = usePortal();
  const { getMyData, data, loading, refresh } = useCrmData();
  const isItPortal = kind === 'it';

  const projects = getMyData('projects');
  const tasks = getMyData('tasks');

  const dashboardTasks = useMemo(() => sortDashboardTasks(tasks), [tasks]);
  const projectGroups = useMemo(
    () => groupProjectsByCompany(projects, data.clients),
    [projects, data.clients],
  );

  return (
    <>
      <PageHeader
        title="Dashboard"
        actions={
          <button type="button" className="btn-secondary btn-sm" onClick={() => void refresh()} disabled={loading}>
            Refresh
          </button>
        }
      />

      <div className="dashboard-layout">
        {!isItPortal ? (
          <div className="dashboard-layout__row">
            <DashboardMonthlySalesChart />
          </div>
        ) : null}

        <DashboardTasksPanel tasks={dashboardTasks} />

        <DashboardProjectsByCompany
          groups={projectGroups}
          projects={projects}
          updates={data.updates}
          users={data.users}
        />

        {!isItPortal ? (
          <div className="dashboard-layout__row">
            <DashboardMonthlyVisitation />
          </div>
        ) : null}
      </div>
    </>
  );
}
